module.exports = __webpack_public_path__ + "img/srs.2d8b933d.svg";